<template>
  <div class="homework-statis-head">
    <div class="title">课程作业信息</div>
    <div class="hw-name">作业名称：{{homeworkData.homework_name}}</div>
    <div>
      <div class="base-row">
        <div>
          <label>课程分类：</label>
          <span>{{homeworkData.course_classify}}</span>
        </div>
        <div>
          <label>所属课程：</label>
          <span>{{homeworkData.title}}</span>
        </div>
        <div>
          <label>课程类型：</label>
          <span>{{homeworkData.course_type_name}}</span>
        </div>
      </div>
      <div class="base-row">
        <div>
          <label>讲师名称：</label>
          <span>{{homeworkData.teacher_name}}</span>
        </div>
        <div>
          <label>作业所属课时：</label>
          <span>{{homeworkData.course_periods_title}}</span>
        </div>
        <div>
          <label>应交作业数：</label>
          <span>{{homeworkData.should_submit_num}}份</span>
        </div>
      </div>
      <div class="base-row">
        <div>
          <label>作业发布时间：</label>
          <span>{{homeworkData.publish_time|tsFormat("yyyy-MM-dd hh:mm")}}</span>
        </div>
        <div>
          <label>作业截止时间：</label>
          <span>{{homeworkData.end_time|tsFormat("yyyy-MM-dd hh:mm")}}</span>
        </div>
        <div>
          <label>已交作业数：</label>
          <span>{{homeworkData.checked_num+homeworkData.unchecked_num}}份</span>
        </div>
      </div>
      <div class="base-row">
        <div>
          <label>已批阅：</label>
          <span>{{homeworkData.checked_num}}份</span>
        </div>
        <div>
          <label>未批阅：</label>
          <span>{{homeworkData.unchecked_num}}份</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CouseType } from "@/utils/enums";
export default {
  name: "homework-statis-head",
  props: {
    mode: {
      type: String,
      default: "teacher"
    },
    hwId: {
      required: true
    },
    classId: {
      default: undefined
    },
    showApproveRate: {
      default: true
    },
    showBottom: {
      default: true
    },
    baseInfo: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      homeworkData: {}
    };
  },
  created() {
    this.requestHomeworkData();
  },
  methods: {
    async requestHomeworkData() {
      let data = await this.$http.get(
        `/api/homework/course/info/${this.hwId}`,
        {
          class_id: this.classId
        }
      );
      data.course_type_name = CouseType.getValue(data.course_type);
      this.homeworkData = data;
    }
  }
};
</script>

<style lang="scss" scoped>
.homework-statis-head {
  .hw-name {
    font-size: 24px;
    text-align: center;
    margin-bottom: 15px;
  }
  .base-row {
    font-size: 16px;
    margin-bottom: 15px;
    display: flex;
    > div {
      width: 33.33%;
    }
    label {
      display: inline-block;
      width: 120px;
      text-align: right;
    }
  }
}
</style>